import { Component, OnInit, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'mm-scrap-confirm-icon',
  templateUrl: './scrap-confirm-icon.component.html',
  styleUrls: ['./scrap-confirm-icon.component.scss']
})
export class ScrapConfirmIconComponent implements OnInit {

  constructor() { }

  @Output() confirm = new EventEmitter();
  ngOnInit(): void {
    
  }

}




